export type Params = {
    eventId: number,
};

export const createEventRoutePath = (params: Params) => {
    return `/events/${params.eventId}`;
};
